var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H27C28.3807 0.5 29.5 1.61929 29.5 3V27C29.5 28.3807 28.3807 29.5 27 29.5H3C1.61929 29.5 0.5 28.3807 0.5 27V3L0.512695 2.74414C0.640824 1.48361 1.70566 0.5 3 0.5Z",
    stroke: "#E3791F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8633 22.2891C18.5821 22.5703 18.126 22.5703 17.8448 22.2891L11.087 15.5323C10.8058 15.2512 10.8059 14.795 11.087 14.5137C11.0933 14.5074 11.1019 14.5032 11.1084 14.4971C11.1165 14.4883 11.1223 14.4774 11.1309 14.4688L17.8877 7.71101C18.1689 7.4298 18.6251 7.4298 18.9063 7.71101C19.1875 7.99221 19.1875 8.44836 18.9063 8.72956L12.6143 15.0216L18.8633 21.2706C19.1444 21.5517 19.1442 22.0079 18.8633 22.2891Z",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerBackButton);
export default __webpack_public_path__ + "static/media/partner-back-button.c4691402e5bd857835609e364641c612.svg";
export { ForwardRef as ReactComponent };